































import Vue from 'vue';
import Component from 'vue-class-component';
import { State } from 'vuex-class';

const Props = Vue.extend({
	props: {
		/** The v-model value */
		openPopInControleDate: {
			type: Boolean,
			default: false
		},
		dateControl: {
			type: String,
			required: true
		},
		rang: {
			type: Number,
			required: true
		}
	}
});

@Component({
	model: {
		prop: 'openPopInControleDate',
		event: 'change'
	}
})
export default class PopInControleDate extends Props {
	get computedValue(): boolean {
		return this.openPopInControleDate;
	}

	set computedValue(value: boolean) {
		this.$emit('change', value);
	}

	getPreviousVacciLabel(rang: number) {
		const previousRang = rang - 1;
		if (previousRang === 1) {
			return '1ère';
		}
		return previousRang + 'ème';
	}
}
